//import  'rxjs/add/operator/do';
import { Injectable } from '@angular/core';
import { LoginService } from '../login.service';
import { CommonService } from '../Common.service';
import { LoaderService } from '../Loader/loader.service';
import { NotificationService } from '../notification.service';
import { EncryptDecryptService } from '../encrypt-decrypt.service';
import { HttpRequest, HttpResponse, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs'; 
import { tap } from 'rxjs/operators'; 

@Injectable({
  providedIn: 'root'
})
export class GlobalHttpInterceptor implements HttpInterceptor {
  private requests: HttpRequest<any>[] = [];
  constructor(private encryptDecryptService: EncryptDecryptService, private loaderService: LoaderService, private commonService: CommonService, private loginService: LoginService, private _notificationService: NotificationService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.loaderService.isLoading.next(true);
    let urlParts = request.url.split('/');
    let Controller = urlParts[urlParts.length - 2];

    if (Controller != "Login" && Controller != "authcallback" && !this.commonService.hasJWT()) {
      this.loaderService.isLoading.next(false);
      this._notificationService.showPopup("Token should not be null or empty", "Warning").then(
        x => {
          const url = window.location.href;
          const path = new URL(url).pathname;
          // this.commonService.isAccesingPRAddCommentsPage = (path === '/peer-review/review-add-comments');
          if (path == '/peer-review/review-add-comments'){
            this.commonService.isAccesingPRAddCommentsPage = true;
            const urlParams = new URLSearchParams(window.location.search);
            const reqNo = urlParams.get('reqno');
            const projId = urlParams.get('proj');
            const gid    = urlParams.get('gid');
            this.commonService.redirectUserToPRAddComments_Projectid = projId;
            this.commonService.redirectUserToPRAddComments_ReqNo = reqNo;
            this.commonService.redirectUserToPRAddComments_GrpID = gid;
          }
          else
          {
            this.commonService.isAccesingPRAddCommentsPage = false;
          }
          this.loginService.Logout(this.commonService.getLoggedInUserStatus())}
      );
      return new Observable<any>();
    }

    request = request.clone({
      setHeaders: {
        'X-Requested-With': 'XMLHttpRequest',
        'Authorization': 'Bearer ' + this.commonService.getJWT(),
        'loginAuditNumber': this.encryptDecryptService.decrypt(this.commonService.getLoginAuditNumber())
      },
    });

    this.requests.push(request);
    return next.handle(request)
    .pipe(tap((event: HttpEvent<any>) => {
    //.do((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        this.removeRequest(request);
      }
    }, (err: any) => {
      this.removeRequest(request);
    }, () => {
      this.removeRequest(request);
    }));
  }

  removeRequest(req: HttpRequest<any>) {
    const index = this.requests.indexOf(req, 0);
    if (index > -1) {
      this.requests.splice(index, 1);
      this.loaderService.isLoading.next(false);
    }
  }

}
